import {Box} from "@hosttools/frontend";
import type {ReactNode} from "react";

type Props = {
    children: ReactNode;
};

const CardBody = ({children}: Props) => {
    return <Box className="p-4 pb-8 z-">{children}</Box>;
};

export default CardBody;
